import { ComponentRef, TemplateRef, Type } from '@angular/core';
import { ToastItem, ToastAction } from '@inscomponents/core';
import { IconName } from '@skylab-assets/icons';
import { BaseNotificationComponentDataConfig, BaseNotificationDataConfig, BaseNotificationTemplateDataConfig } from '../popover/base-popover';
import { NotificationItemConfig } from '../popover/notification/notification-stack.service';
import { ToastConfig } from '../popover/toast-popover.component';

const SUPPORTED_TYPES = new Set(['error', 'warning', 'info', 'success', 'pending'] as const);

type SupportedToastType = ToastConfig['type'];

function mapType(type: ToastItem['type']): SupportedToastType | undefined {
	if (!type) return;

	return SUPPORTED_TYPES.has(type as any) ? (type as SupportedToastType) : undefined;
}

function mapActions(actions?: ToastAction[]): ToastConfig['actions'] | undefined {
	if (!actions?.length) return;

	return actions.map(action => ({
		text: action.text,
		action: () => action.handler?.(),
	}));
}

export function toastItemToConfig(item: ToastItem): NotificationItemConfig {
	const type = mapType(item.type);
	const legacyItem = item;

	const baseData = {
		title: item.title,
		icon: item.icon as IconName,
	};

	let data: NotificationItemConfig['data'];

	if (legacyItem.content instanceof TemplateRef) {
		data = {
			...baseData,
			content: legacyItem.content,
			context: legacyItem.contentProps,
		} as BaseNotificationTemplateDataConfig;
	} else if (legacyItem.content) {
		data = {
			...baseData,
			content: legacyItem.content as Type<any>,
			contentProps: legacyItem.contentProps,
		} as BaseNotificationComponentDataConfig;
	} else {
		data = {
			...baseData,
			content: item.text ?? '',
		} as BaseNotificationDataConfig;
	}

	return {
		type,
		closeButton: item.showCloseButton ?? true,
		duration: item.duration,
		actions: mapActions(item.actions),
		data,
		...(item.cssClass ? { cssClass: item.cssClass } : {}),
		...(item.cssStyle ? { cssStyle: item.cssStyle } : {}),
	};
}
